import styled from 'styled-components'

const StyledPaymentMethodCard = styled.div`
  
`

export default StyledPaymentMethodCard
